import { OrganizationProfile } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_users/OrganizationManagement')({
  component: OrganizationManagement,
});

function OrganizationManagement() {
  return <OrganizationProfile />;
}
